import React from 'react';
import { Link } from 'react-router-dom';

import 'Components/FacetSearch/FranchiseImgGrid.scss';

import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';
import FluidImg from 'Components/Utility/FluidImg';
import FluidBackgroundImg from 'Components/Utility/FluidBackgroundImg';
import { getRankedFranchises } from 'Helpers/Franchise/FranchiseHelper';


const FranchiseImgGrid = () => {
  const franchises = getRankedFranchises();

  const heights = {
    xs: 180,
    sm: 180,
    md: 200,
    lg: 230,
    xl: 224,
    xxl: 268,
  };

  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    md: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    lg: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
    xxl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  };

  return (
    <SiteSlider sliderClass="franchise-img-carousel" sliderSettings={sliderSettings}>
      {franchises.slice(0, 15).map(franchise =>
        <Link to={`/franchises/${franchise.slug}`} key={franchise.slug} className={`franchise-grid-segment ${franchise.slug}-segment`}>
          <div className={`franchise-bg ${franchise.slug}-bg`}>
            <FluidBackgroundImg
              folder="assets/franchises"
              className="img-force-full"
              src={franchise.bgImg}
              heights={heights}
              alt={franchise.alt}
              widthOverride={250}
              fit="crop"
            />
          </div>
          <div className="franchise-logo">
            <FluidImg
              folder="assets/franchises"
              className={`img-force-full ${franchise.slug}`}
              src={franchise.logo}
              alt={franchise.alt}
            />
          </div>
        </Link>,
      )}
    </SiteSlider>
  );
};

export default FranchiseImgGrid;
